import React from 'react';

const iconMap = {
  // Navigation icons (both cases for compatibility)
  'home': '🏠',
  'Home': '🏠',
  'user': '👤',
  'User': '👤',
  'book': '📚',
  'Book': '📚',
  'calendar': '📅',
  'Calendar': '📅',
  'credit-card': '💳',
  'CreditCard': '💳',
  'trophy': '🏆',
  'Trophy': '🏆',
  'settings': '⚙️',
  'Settings': '⚙️',
  'shopping-cart': '🛒',
  'ShoppingCart': '🛒',
  'file-text': '📄',
  'FileText': '📄',
  'bar-chart': '📊',
  'BarChart3': '📊',
  'clock': '⏰',
  'Clock': '⏰',
  'check-circle': '✅',
  'CheckCircle': '✅',
  'x-circle': '❌',
  'XCircle': '❌',
  'play': '▶️',
  'Play': '▶️',
  'lock': '🔒',
  'Lock': '🔒',
  'star': '⭐',
  'Star': '⭐',
  'search': '🔍',
  'Search': '🔍',
  'bell': '🔔',
  'Bell': '🔔',
  'plus': '➕',
  'Plus': '➕',
  'filter': '🔽',
  'Filter': '🔽',
  'eye': '👁️',
  'Eye': '👁️',
  'edit': '✏️',
  'Edit': '✏️',
  'trash-2': '🗑️',
  'Trash2': '🗑️',
  'users': '👥',
  'Users': '👥',
  'graduation-cap': '🎓',
  'GraduationCap': '🎓',
  'book-open': '📖',
  'BookOpen': '📖',
  'award': '🏅',
  'Award': '🏅',
  'trending-up': '📈',
  'TrendingUp': '📈',
  'activity': '📊',
  'Activity': '📊',
  'globe': '🌍',
  'Globe': '🌍',
  'menu': '☰',
  'Menu': '☰',
  'x': '✖️',
  'X': '✖️',
  'download': '⬇️',
  'Download': '⬇️',
  'upload': '⬆️',
  'Upload': '⬆️',
  'arrow-left': '←',
  'ArrowLeft': '←',
  'chevron-right': '→',
  'ChevronRight': '→',
  'chevron-left': '←',
  'ChevronLeft': '←',
  'chevron-down': '▼',
  'ChevronDown': '▼',
  'message-circle': '💬',
  'MessageCircle': '💬',
  'send': '📤',
  'Send': '📤',
  'heart': '❤️',
  'Heart': '❤️',
  'share-2': '📤',
  'Share2': '📤',
  'bookmark': '🔖',
  'Bookmark': '🔖',
  'play-circle': '⏯️',
  'PlayCircle': '⏯️',
  'pie-chart': '🥧',
  'PieChart': '🥧',
  'line-chart': '📈',
  'LineChart': '📈',
  'target': '🎯',
  'Target': '🎯',
  'zap': '⚡',
  'Zap': '⚡',
  'refresh-cw': '🔄',
  'RefreshCw': '🔄',
  'clipboard': '📋',
  'Clipboard': '📋',
  'chart': '📊',
  'Chart': '📊',
  'log-out': '🚪',
  'LogOut': '🚪'
};

const Icon = ({ name, className = '', size = 16, style = {} }) => {
  const emoji = iconMap[name] || '❓';
  
  return (
    <span 
      className={`inline-block ${className}`}
      style={{ 
        fontSize: `${size}px`, 
        lineHeight: 1,
        ...style 
      }}
      role="img"
      aria-label={name}
    >
      {emoji}
    </span>
  );
};

export default Icon; 